<template>
	<template v-if="participant.video">
		<div class="bg-[#1C1C1E] w-full h-full rounded-2xl overflow-hidden transform-gpu">
			    <audio autoPlay playsInline :srcObject="audioSource">
			     	<track kind="captions" />
			    </audio>
			    <video class="w-full h-full object-cover -scale-x-[1]" autoPlay muted playsInline :srcObject="videoSource"></video>
				<!-- <div>{{ props.participant.name }}</div> -->
		</div>
	</template>
	<template v-else>
		<div>
			<div>No video</div>
			<div>{{ props.participant.name }}</div>
		</div>
	</template>

<!-- 	<template v-if="participant.local">
		<div class="fixed w-full flex items-center justify-center bottom-0">
			Mute | Camera | Leave
		</div>
	</template> -->
</template>

<script setup>
import { ref, defineProps, onMounted, onUpdated } from 'vue'

const props = defineProps(['participant'])
const audioSource = ref(null)
const videoSource = ref(null)

onMounted(() => {
	handleVideo(props.participant)
	handleAudio(props.participant)
})

onUpdated(() => {
	handleVideo(props.participant)
	handleAudio(props.participant)
})

const handleVideo = () => {
	const p = props.participant
	if (!p?.video) return
	const track = p.tracks.video.persistentTrack
	const newStream = updateSource(videoSource.value, track)
	if (newStream) {
		videoSource.value = newStream
	}
}

const handleAudio = () => {
	const p = props.participant
	if (!p || p.local || !p.audio) return
	const track = p.tracks.audio.persistentTrack
	const newStream = updateSource(audioSource.value, track)
	if (newStream) {
		audioSource.value = newStream
	}
}

const updateSource = (stream, newTrack) => {
	const existingTracks = stream?.getTracks()
	if (!existingTracks || existingTracks.length === 0) {
		return new MediaStream([newTrack])
	}
	if (existingTracks.length > 1) {
		console.warn(
			`expected 1 track, found ${existingTracks.length}. Only using the first one.`
			)
	}
	const existingTrack = existingTracks[0]
	if (newTrack.id !== existingTrack.id) {
		stream.removeTrack(existingTrack)
		stream.addTrack(newTrack)
	}
	return null
}
</script>